import { Injectable } from '@angular/core';

import { Fixture, FixturePage, FixtureStage } from '@cds/betting-offer';
import { ISchemaMarkupResolver } from '@frontend/sports/schema-markup/feature';
import { Observable, of } from 'rxjs';

@Injectable()
export class EventListSchemaMarkupResolver implements ISchemaMarkupResolver<FixturePage> {
    constructor() {}

    resolve(tournamentOverview: FixturePage): Observable<Fixture[]> {
        if (tournamentOverview && tournamentOverview.fixtures && tournamentOverview.fixtures.length > 0) {
            return of(tournamentOverview.fixtures.filter((fixture) => fixture.stage && fixture.stage !== FixtureStage.Live));
        }

        return of([]);
    }
}
